import Const from 'constants';

function isInnerBoundariesOutOfOuter(inner, outer) {
    return inner.min < outer.min || inner.max > outer.max;
}

const defaultStateData = {
    inner: {
        min: Const.DEFAULT_VALUE_FOR_MIN_SALARY_CAP,
        max: Const.DEFAULT_VALUE_FOR_MAX_SALARY_CAP,
    },
    outer: {
        min: Const.DEFAULT_VALUE_FOR_MIN_SALARY_CAP,
        max: Const.DEFAULT_VALUE_FOR_MAX_SALARY_CAP,
    },
    isInnerBoundariesDefault: true,
    isOuterBoundariesDefault: true,
};

class State {
    data;
    constructor(data) {
        this.data = data;
    }
    isInnerMinDefault = () => this.getInnerMin() === Const.DEFAULT_VALUE_FOR_MIN_SALARY_CAP;
    isInnerBoundariesDefault = () => this.data.isInnerBoundariesDefault;
    isOuterBoundariesDefault = () => this.data.isOuterBoundariesDefault;
    getInnerCapBoundaries = () => ({...this.data.inner});
    getInnerCapBoundary = (capName) => Number(this.data.inner[capName]);
    getOuterCapBoundary = (capName) => Number(this.data.outer[capName]);
    getInnerMin = () => this.getInnerCapBoundary('min');
    getInnerMax = () => this.getInnerCapBoundary('max');
    getOuterMin = () => this.getOuterCapBoundary('min');
    getOuterMax = () => this.getOuterCapBoundary('max');
}

const defaultState = new State(cp(defaultStateData));

export default function (state = defaultState, action) {
    if (action.type === Const.SALARY_CAP_SET_INNER) {
        const data = cp(state.data);
        data.inner = {...state.data.inner, ...action.data};
        data.isInnerBoundariesDefault = false;
        state = new State(data);
    } else if (action.type === Const.SALARY_CAP_SET_OUTER) {
        const data = cp(state.data);
        const prevOuter = data.outer;

        data.outer = cp(action.data);
        data.isOuterBoundariesDefault = false;

        if (state.isInnerBoundariesDefault() || isInnerBoundariesOutOfOuter(data.inner, data.outer)) {
            data.inner = {...data.outer};
            data.isInnerBoundariesDefault = false;
        } else {
            if (data.inner.max === prevOuter.max) {
                data.inner.max = data.outer.max;
            }
            if (data.inner.min === prevOuter.min) {
                data.inner.min = data.outer.min;
            }
        }
        state = new State(data);
    } else if (inArray(action.type, [Const.FILTER_BY_SLATE, Const.RESET_ALL_SETTINGS])) {
        state = new State(cp(defaultStateData));
    }

    return state;
}
